<template>
  <TableLayout :permissions="['business:multifile:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="主键" prop="id">
          <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建人编码" prop="creator">
          <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
        </el-form-item>
        <el-form-item label="更新人编码" prop="editor">
          <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="editDate">
          <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
        </el-form-item>
        <el-form-item label="是否删除0否 1是" prop="isdeleted">
          <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="文件名" prop="name">
          <el-input v-model="searchForm.name" placeholder="请输入文件名" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="info">
          <el-input v-model="searchForm.info" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联对象编码" prop="objId">
          <el-input v-model="searchForm.objId" placeholder="请输入关联对象编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="类型0图片 1视频 2其他" prop="type">
          <el-input v-model="searchForm.type" placeholder="请输入类型0图片 1视频 2其他" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联对象类型 0SHE上报 1安全风险上报 2安全风险处理 3安全风险分配物业主管 4安全风险分配处理人 5DCA风险上报 6DCA风险处理" prop="objType">
          <el-input v-model="searchForm.objType" placeholder="请输入关联对象类型 0SHE上报 1安全风险上报 2安全风险处理 3安全风险分配物业主管 4安全风险分配处理人 5DCA风险上报 6DCA风险处理" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="文件地址" prop="fileurl">
          <el-input v-model="searchForm.fileurl" placeholder="请输入文件地址" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="排序码" prop="sortnum">
          <el-input v-model="searchForm.sortnum" placeholder="请输入排序码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="企业编码(关联company表）" prop="companyId">
          <el-input v-model="searchForm.companyId" placeholder="请输入企业编码(关联company表）" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:multifile:create', 'business:multifile:delete']">
        <li><el-button type="primary" @click="$refs.operaMultifileWindow.open('新建附件上传信息表')" icon="el-icon-plus" v-permissions="['business:multifile:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:multifile:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="文件名" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="关联对象编码" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型0图片 1视频 2其他" min-width="100px"></el-table-column>
        <el-table-column prop="objType" label="关联对象类型 0SHE上报 1安全风险上报 2安全风险处理 3安全风险分配物业主管 4安全风险分配处理人 5DCA风险上报 6DCA风险处理" min-width="100px"></el-table-column>
        <el-table-column prop="fileurl" label="文件地址" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码" min-width="100px"></el-table-column>
        <el-table-column prop="companyId" label="企业编码(关联company表）" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:multifile:update', 'business:multifile:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaMultifileWindow.open('编辑附件上传信息表', row)" icon="el-icon-edit" v-permissions="['business:multifile:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:multifile:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaMultifileWindow ref="operaMultifileWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import OperaMultifileWindow from '@/components/business/OperaMultifileWindow'
export default {
  name: 'Multifile',
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, OperaMultifileWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        name: '',
        info: '',
        objId: '',
        type: '',
        objType: '',
        fileurl: '',
        sortnum: '',
        companyId: ''
      }
    }
  },
  created () {
    this.config({
      module: '附件上传信息表',
      api: '/business/multifile',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
